import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppointmentRequestQueryPost } from '@warema/shared/models';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchDataService } from './search-data.service';
import { ActivityDataService } from '../../activity/services/activity-data.service';
import { ProductCategoryDataService } from '../../product-category/services/product-category-data.service';

@Injectable({
    providedIn: 'root',
})
export class AppointmentRequestQueryGeneratorService {
    private readonly _productCategoryDataService = inject(ProductCategoryDataService);
    private readonly _activityDataService = inject(ActivityDataService);
    private readonly _searchDataService = inject(SearchDataService);
    private readonly _route = inject(ActivatedRoute);

    public generateAppointmentRequestQuery(): Observable<AppointmentRequestQueryPost> {
        return combineLatest([
            this._productCategoryDataService.selectedSubProductCategoriesIds$.pipe(map(x => x.join(','))),
            this._activityDataService.selectedActivity$,
            this._searchDataService.latestSearchedCoordinates$.pipe(map(x => x.address)),
            this._searchDataService.selectedCompanyAddressId$,
            this._route.queryParamMap,
        ]).pipe(
            map(
                ([
                    productCategories,
                    activity,
                    searchedAddress,
                    companyAddressId,
                    paramsMap,
                ]): AppointmentRequestQueryPost => {
                    const values = [
                        { key: 'productCategories', value: productCategories },
                        { key: 'activity', value: activity },
                        { key: 'origin', value: paramsMap.get('origin') },
                        { key: 'address', value: searchedAddress },
                    ];

                    return {
                        companyAddressId,
                        values,
                    };
                },
            ),
        );
    }
}
